const coinFormatter = new Intl.NumberFormat('ru-RU', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

const coinCompact = new Intl.NumberFormat('ru-RU', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
})

const countFormatter = new Intl.NumberFormat('ru-RU')

/** Форматирование целого количества с разделением тысяч: «23 707». */
export function formatCount(count) {
  if (count === null || count === undefined || Number.isNaN(Number(count))) return '0'
  return countFormatter.format(Math.round(Number(count)))
}

/** Число монет → «1 234,56». */
export function formatCoins(kopecks) {
  return coinFormatter.format((kopecks ?? 0) / 100)
}

/** Число монет без лишних нулей, но с сохранением копеек при их наличии: «0,45», «1 235». */
export function formatCoinsShort(kopecks) {
  if (kopecks === null || kopecks === undefined || Number.isNaN(kopecks)) return '0'
  const kop = Number(kopecks)
  const val = kop / 100
  if (kop % 100 !== 0) {
    return coinFormatter.format(val)
  }
  return coinCompact.format(val)
}

/**
 * Только форматированное число цены:
 * Сохраняет точные копейки («0,45», «25 835,77»), не округляя копеечные предметы до 0.
 * Если цена круглая (например цена кейса 2999), отображает без лишних нулей («2 999»).
 */
export function formatCoinsNum(kopecks) {
  if (kopecks === null || kopecks === undefined || Number.isNaN(kopecks)) return '0'
  const kop = Number(kopecks)
  const val = kop / 100
  if (kop % 100 !== 0) {
    return coinFormatter.format(val)
  }
  return coinCompact.format(val)
}

/** Обратная совместимость: валюта платформы теперь CM COIN (без текстовой приписки CM) */
export const formatRub = formatCoins
export const formatRubShort = formatCoinsShort


/** Доля → «12.34%». Точные сотые доли процента без грубого округления до десятых. */
export function formatChance(chance) {
  const percent = (chance ?? 0) * 100
  if (percent === 0) return '0%'
  if (percent < 0.01) return `${percent.toFixed(4)}%`
  return `${percent.toFixed(2)}%`
}

export function formatFloat(value) {
  return (value ?? 0).toFixed(6)
}

export function formatDate(iso) {
  if (!iso) return '—'
  // SQLite отдаёт «YYYY-MM-DD HH:MM:SS» в UTC без суффикса.
  const normalized = iso.includes('T') ? iso : `${iso.replace(' ', 'T')}Z`
  const date = new Date(normalized)
  if (Number.isNaN(date.getTime())) return iso
  return new Intl.DateTimeFormat('ru-RU', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date)
}

/** Правильная форма слова: 1 кейс, 2 кейса, 5 кейсов. */
export function plural(count, one, few, many) {
  const mod100 = count % 100
  const mod10 = count % 10
  if (mod100 >= 11 && mod100 <= 14) return many
  if (mod10 === 1) return one
  if (mod10 >= 2 && mod10 <= 4) return few
  return many
}

export const RARITY_LABELS = {
  consumer: 'Ширпотреб',
  industrial: 'Промышленное',
  milspec: 'Армейское',
  restricted: 'Запрещённое',
  classified: 'Засекреченное',
  covert: 'Тайное',
  exceedingly: 'Особо редкое',
}

export const RARITY_COLORS = {
  consumer: '#b0c3d9',
  industrial: '#5e98d9',
  milspec: '#4b69ff',
  restricted: '#8847ff',
  classified: '#d32ce6',
  covert: '#eb4b4b',
  exceedingly: '#ffd700',
}

export const WEAR_SHORT = {
  fn: 'FN',
  mw: 'MW',
  ft: 'FT',
  ww: 'WW',
  bs: 'BS',
}

export const WEAR_FULL = {
  fn: 'Прямо с завода',
  mw: 'Немного поношенное',
  ft: 'После полевых испытаний',
  ww: 'Поношенное',
  bs: 'Закалённое в боях',
}

export const WEAR_FRIENDLY = {
  fn: 'После полевых',
  fn_full: 'Прямо с завода',
  fn: 'Прямо с завода',
  mw: 'Немного поношенное',
  ft: 'После полевых',
  ww: 'Поношенное',
  bs: 'Закалённое',
}

export function getWearFriendlyLabel(item) {
  if (!item) return null
  const wearKey = item.wear?.toLowerCase()
  if (wearKey && WEAR_FRIENDLY[wearKey]) return WEAR_FRIENDLY[wearKey]
  if (item.wearLabel) {
    if (item.wearLabel.includes('После полевых')) return 'После полевых'
    if (item.wearLabel.includes('Закалённое')) return 'Закалённое'
    if (item.wearLabel.includes('Прямо с завода')) return 'Прямо с завода'
    if (item.wearLabel.includes('Немного поношенное')) return 'Немного поношенное'
    if (item.wearLabel.includes('Поношенное')) return 'Поношенное'
    return item.wearLabel
  }
  return null
}

export function getWearLabel(item) {
  if (!item) return null
  if (item.wearLabel) return item.wearLabel
  if (item.wear && WEAR_FULL[item.wear]) return WEAR_FULL[item.wear]
  return null
}

export const SOURCE_LABELS = {
  craft: 'Контракт',
  upgrade: 'Апгрейд',
  bonus: 'Бонус',
}

export function sourceLabel(source) {
  if (!source) return '—'
  if (source.startsWith('case:')) return 'Кейс'
  return SOURCE_LABELS[source] ?? source
}
